import { readSettings } from '../../helpers/board';

let patientInfo = null;
let pickupType = '1';
export default async function allApiCall(fileObj, payload) {
  try {
    pickupType =
      localStorage.getItem('pickupType') !== null
        ? localStorage.getItem('pickupType')
        : '1';
    let sourceEnabled;
    if (window.electron) {
      const fileData = JSON.parse(readSettings());
      sourceEnabled = fileData ? fileData.dynamicDataSource : false;
    } else {
      sourceEnabled = JSON.parse(localStorage.getItem('dynamicDataSource'));
    }
    patientInfo = JSON.parse(localStorage.getItem('patient'));
    if (payload && payload.requestPayload) {
      if (payload.requestPayload.length > 0) {
        if (sourceEnabled === true) {
          for (let i = 0; payload.requestPayload.length > i; i++) {
            if (payload.requestPayload[i].name === 'saveKioskCustomer') {
              saveConfirmUser(payload.box, payload.requestPayload[i]);
            }
            if (payload.requestPayload[i].name === 'updateStatusOfRx') {
              UpdateStatusOfRx(payload.requestPayload[i]);
            }
          }
        } else {
          for (let i = 0; payload.requestPayload.length > i; i++) {
            if (payload.requestPayload[i].name === 'sendEmail') {
              sendMail(payload.requestPayload[i]);
            }
          }
        }
      }
    }
    let patient = JSON.parse(localStorage.getItem('patient'));
    patient = patient ? patient : {};
    patient[0].signature_url = '';
    patient[0].picture_url = '';
    localStorage.setItem('patient', JSON.stringify(patient));
  } catch (e) {
    console.log(e);
  }
}

//Save KIOSK_CONFIRM_USER
async function saveConfirmUser(box, payload) {
  let order_id = patientInfo[0].orders[0].id;
  let orderIds = [];
  if (pickupType === '1') {
    orderIds.push({ id: patientInfo[0].orders[0].id });
  } else if (pickupType === '2') {
    patientInfo[0].orders.map(order => {
      orderIds.push({ id: order.id });
      return true;
    });
  }
  let customer_id = patientInfo[0].id;
  let account_id = box.parent_account_id;
  let box_id = box.id;
  let base64Picture = null;
  let base64Signature = null;
  if (
    patientInfo[0].picture_url !== null &&
    patientInfo[0].picture_url !== '' &&
    patientInfo[0].picture_url !== undefined
  ) {
    base64Picture = patientInfo[0].picture_url.replace(
      /^data:image\/\w+;base64,/,
      ''
    );
  }
  if (
    patientInfo[0].signature_url !== null &&
    patientInfo[0].signature_url !== '' &&
    patientInfo[0].signature_url !== undefined
  ) {
    base64Signature = patientInfo[0].signature_url.replace(
      /^data:image\/\w+;base64,/,
      ''
    );
  }

  let data = new FormData();
  data.append('customer_id', customer_id);
  data.append('order_id', order_id);
  data.append('picture_url', base64Picture);
  data.append('signature_url', base64Signature);
  data.append('drivers_license_no', payload.body.formData.DriversLicenseNo);
  data.append('first_name', payload.body.formData.FirstName);
  data.append('middle_name', null);
  data.append('last_name', payload.body.formData.LastName);
  data.append('dob', payload.body.formData.dateOfBirth);
  data.append('relationship', payload.body.formData.value);
  data.append('box_id', box_id);
  data.append('account_id', account_id);
  data.append('orderIds', JSON.stringify(orderIds));
  data.append('selectedStateCode', payload.body.formData.selectedStateCode);
  data.append('dlrawdata', payload.body.formData.dlrawdata);
  data.append(
    'kioskBoxAccountConnection',
    payload.body.formData.kioskBoxAccountConnection
  );
  data.append('is_consult_requested', payload.body.formData.isConsultRequested);
  fetch(payload.url, {
    method: payload.type,
    body: data
  })
    .then(response => {
      try {
        return response.text();
      } catch (error) {
        return null;
      }
    })
    .then(uData => {
      if (uData !== null && uData.length > 0) {
      }
    });
}

//KIOSK_DOOR_COLLECT_SEND_EMAIL
async function sendMail(payload) {
  let pickupConfig = payload.body.pickupConfig;
  let tempConfigObj = { pickupConfig };
  fetch(payload.url, {
    method: payload.type,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(tempConfigObj)
  }).then(response => {
    try {
      return response.text();
    } catch (error) {
      return null;
    }
  });
}

//KIOSK_DOOR_COLLECT_UpdateStatusOfRx
async function UpdateStatusOfRx(payload) {
  fetch(payload.url, {
    method: payload.type,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload.body.updateStatusOfRxObj)
  })
    .then(response => {
      try {
        return response.text();
      } catch (error) {
        return null;
      }
    })
    .then(RxObj => {});
}
